"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.splice.js");

var _dom = require("element-ui/lib/utils/dom");

var _vue = _interopRequireDefault(require("vue"));

var nodeList = [];
var ctx = '@@clickoutsideContext';
var startClick;
var seed = 0;
!_vue["default"].prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
  startClick = e;
});
!_vue["default"].prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var extendContainers = el.getAttribute('extend-container');
    var extendContainerEls = [];

    if (extendContainers) {
      extendContainers = extendContainers.split(',');

      for (var i = 0; i < extendContainers.length; i++) {
        extendContainerEls.push.apply(extendContainerEls, (0, _toConsumableArray2["default"])(document.querySelectorAll(extendContainers[i].trim())));
      }
    }

    var constained = false;

    if (extendContainerEls) {
      for (var _i = 0; _i < extendContainerEls.length; _i++) {
        var extendContainerEl = extendContainerEls[_i];

        if (extendContainerEl.contains(mouseup.target) || extendContainerEl.contains(mousedown.target)) {
          constained = true;
          break;
        }
      }
    }

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target)) || constained) {
      return;
    }

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName](mouseup || mousedown);
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn(mouseup || mousedown);
    }
  };
}
/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */


var _default = {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }

    delete el[ctx];
  }
};
exports["default"] = _default;